<app-smash-message-modal
    [title]="'CHUNK_LOAD_ERROR_TITLE' | translate"
    [description]="'CHUNK_LOAD_ERROR_DESCRIPTION' | translate"
    [closeLabel]="'CHUNK_LOAD_ERROR_CLOSE' | translate"
    [primaryLabel]="'CHUNK_LOAD_ERROR_RELOAD' | translate"
    (closed)="ref.close()"
    (primaryAction)="reload()">
</app-smash-message-modal>
